export default function MobileIcon() {
  return (
    <svg width="65" height="64" viewBox="0 0 65 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="path-1-inside-1_3942_27031" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.5 15C24.2909 15 22.5 16.7909 22.5 19V44C22.5 46.2091 24.2909 48 26.5 48H38.5C40.7091 48 42.5 46.2091 42.5 44V19C42.5 16.7909 40.7091 15 38.5 15H26.5ZM31 18C30.7239 18 30.5 18.2239 30.5 18.5C30.5 18.7761 30.7239 19 31 19H34C34.2761 19 34.5 18.7761 34.5 18.5C34.5 18.2239 34.2761 18 34 18H31Z"
        />
      </mask>
      <path
        d="M23.5 19C23.5 17.3431 24.8431 16 26.5 16V14C23.7386 14 21.5 16.2386 21.5 19H23.5ZM23.5 44V19H21.5V44H23.5ZM26.5 47C24.8431 47 23.5 45.6569 23.5 44H21.5C21.5 46.7614 23.7386 49 26.5 49V47ZM38.5 47H26.5V49H38.5V47ZM41.5 44C41.5 45.6569 40.1569 47 38.5 47V49C41.2614 49 43.5 46.7614 43.5 44H41.5ZM41.5 19V44H43.5V19H41.5ZM38.5 16C40.1569 16 41.5 17.3431 41.5 19H43.5C43.5 16.2386 41.2614 14 38.5 14V16ZM26.5 16H38.5V14H26.5V16ZM31.5 18.5C31.5 18.7761 31.2761 19 31 19V17C30.1716 17 29.5 17.6716 29.5 18.5H31.5ZM31 18C31.2761 18 31.5 18.2239 31.5 18.5H29.5C29.5 19.3284 30.1716 20 31 20V18ZM34 18H31V20H34V18ZM33.5 18.5C33.5 18.2239 33.7239 18 34 18V20C34.8284 20 35.5 19.3284 35.5 18.5H33.5ZM34 19C33.7239 19 33.5 18.7761 33.5 18.5H35.5C35.5 17.6716 34.8284 17 34 17V19ZM31 19H34V17H31V19Z"
        fill="white"
        mask="url(#path-1-inside-1_3942_27031)"
      />
      <path
        d="M23.5 19C23.5 17.3431 24.8431 16 26.5 16V14C23.7386 14 21.5 16.2386 21.5 19H23.5ZM23.5 44V19H21.5V44H23.5ZM26.5 47C24.8431 47 23.5 45.6569 23.5 44H21.5C21.5 46.7614 23.7386 49 26.5 49V47ZM38.5 47H26.5V49H38.5V47ZM41.5 44C41.5 45.6569 40.1569 47 38.5 47V49C41.2614 49 43.5 46.7614 43.5 44H41.5ZM41.5 19V44H43.5V19H41.5ZM38.5 16C40.1569 16 41.5 17.3431 41.5 19H43.5C43.5 16.2386 41.2614 14 38.5 14V16ZM26.5 16H38.5V14H26.5V16ZM31.5 18.5C31.5 18.7761 31.2761 19 31 19V17C30.1716 17 29.5 17.6716 29.5 18.5H31.5ZM31 18C31.2761 18 31.5 18.2239 31.5 18.5H29.5C29.5 19.3284 30.1716 20 31 20V18ZM34 18H31V20H34V18ZM33.5 18.5C33.5 18.2239 33.7239 18 34 18V20C34.8284 20 35.5 19.3284 35.5 18.5H33.5ZM34 19C33.7239 19 33.5 18.7761 33.5 18.5H35.5C35.5 17.6716 34.8284 17 34 17V19ZM31 19H34V17H31V19Z"
        fill="black"
        fillOpacity="0.3"
        mask="url(#path-1-inside-1_3942_27031)"
      />
      <path
        d="M48.2818 27C55.6586 28.0848 60.5 29.909 60.5 31.9764C60.5 35.3031 47.964 38 32.5 38C17.036 38 4.5 35.3031 4.5 31.9764C4.5 29.909 9.34138 28.0848 16.7182 27"
        stroke="white"
        strokeMiterlimit="10"
        strokeDasharray="3 3"
      />
      <path
        d="M48.2818 27C55.6586 28.0848 60.5 29.909 60.5 31.9764C60.5 35.3031 47.964 38 32.5 38C17.036 38 4.5 35.3031 4.5 31.9764C4.5 29.909 9.34138 28.0848 16.7182 27"
        stroke="black"
        strokeOpacity="0.3"
        strokeMiterlimit="10"
        strokeDasharray="3 3"
      />
    </svg>
  );
}
